import { styled } from "styled-components";

export const SingUpContaier = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  width: 450px;
`;
